import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '../store/authStore';

function AdminRoute() {
  const { isAuthenticated, user, authChecked } = useAuthStore();

  if (!authChecked) {
    return null;
  }

  // Check if user is authenticated and has admin privileges
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user?.is_admin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export default AdminRoute;
